export const DIRECTIONS = {
  horizontal: 'horizontal',
  vertical: 'vertical',
} as const;

export const SKINS = {
  light: 'light',
  dark: 'dark',
  standard: 'standard',
  warning: 'warning',
  destructive: 'destructive',
  success: 'success',
  premium: 'premium',
} as const;
